/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class Timer extends HTMLElement {
    constructor() {
        super();
        this.timeBox = this.querySelector('[data-time-box]');
        this.utcEndTimeString = this.dataset.endTime;
    }

    connectedCallback() {
        console.log(this.closest('div'), 'this.parentElement.parentElement')
        if(!this.isValidUTCTime(this.utcEndTimeString)) {
            this.closest('div').remove();
            return;
        }
        const [datePart, timePart] = this.utcEndTimeString.split(' ');
        const [day, month, year] = datePart.split('/').map(Number);
        const [hours, minutes, seconds] = timePart.split(':').map(Number);
        this.endTimeUTC = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
        this.startCountdown();
    }

    startCountdown() {
        requestAnimationFrame(this.updateCountdown.bind(this));
    }

    updateCountdown() {
        const currentTimeUTC = new Date();
        const timeLeft = this.endTimeUTC - currentTimeUTC;
        if (timeLeft > 0) {
            const secondsLeft = Math.floor((timeLeft / 1000) % 60);
            const minutesLeft = Math.floor((timeLeft / (1000 * 60)) % 60);
            const hoursLeft = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
            const daysLeft = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

            const formattedTime = `${String(daysLeft).padStart(2, '0')} Tage: ${String(hoursLeft).padStart(2, '0')} Std: ${String(minutesLeft).padStart(2, '0')} Min: ${String(secondsLeft).padStart(2, '0')} Sek`;

            this.timeBox.textContent = formattedTime;

            requestAnimationFrame(this.updateCountdown.bind(this));
        } else {
            console.log('removed');
            this.closest('div').remove();
        }
    }

    isValidUTCTime(utcTimeString) {
        const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d ([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
        return regex.test(utcTimeString);
    }
}

customElements.define("product-timer", Timer);

document.addEventListener('DOMContentLoaded', function() {
    const isPPMEnabled = document.querySelector('.price-main[data-ppm]') !== null;
    if( !isPPMEnabled ) {
        return;
    }

    let priceDisplay, priceCompareDisplay, pricePerMeter, quantityInput, quantity;
    function updateSelectors(){
        priceDisplay = document.querySelector('.product-form__info-content .price-main');
        priceCompareDisplay = document.querySelector('.product-form__info-content .price-secondary');
        pricePerMeter = parseFloat(priceDisplay.dataset.price);
        quantityInput = document.querySelector('.product-form__info-list .quantity-selector__value');
        quantity = parseInt(quantityInput.value, 10);
        updateDisplayUnitValue();

        quantityInput.addEventListener('change', function() {
            quantity = parseInt(quantityInput.value, 10);
            if(isNaN(quantity) || quantity <= 0) {
                quantity = 1;
                quantityInput.value = 1;
            }
            updateDisplayPrice();
            updateDisplayUnitValue();
        });
    }

    function updateDisplayUnitValue(){
        const unitDisplay = document.querySelector('.product-form__quantity-unit');
        if(unitDisplay){
            const quantityUnit = unitDisplay.dataset.quantityUnit;
            const quantityValue = unitDisplay.dataset.quantityValue;
            let quantityUnitSum = quantity * quantityValue;
            quantityUnitSum = new Intl.NumberFormat(Shopify.locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(quantityUnitSum);
            unitDisplay.textContent = quantityUnitSum + " " + quantityUnit;
        }
    }

    function updateDisplayPrice(){
        const formatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });
        let newPrice = pricePerMeter * quantity;
        priceDisplay.textContent = "€" + formatter.format(newPrice / 100).replace("€", "").trim();

        if(priceCompareDisplay){
            let priceCompare = parseFloat(priceCompareDisplay.dataset.price);
            let newPriceCompare = priceCompare * quantity;
            priceCompareDisplay.textContent = "€" + formatter.format(newPriceCompare / 100).replace("€", "").trim();
        }
    }

    function setUpObserver(){
        const productForm = document.querySelector('product-form');
        if (productForm) {
            const observer = new MutationObserver(() => {
                observer.disconnect();
                updateSelectors();
                updateDisplayPrice();
                setUpObserver();
            });
            observer.observe(productForm, { childList: true, subtree: true });
        }
    }
    setUpObserver();
    updateSelectors();
});

(function() {
  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (!ogUrl || ogUrl.getAttribute('content') !== 'https://hd-terrassenshop.de/pages/terrassenueberdachung-konfigurator') return;

  const style = document.createElement('style');
  style.textContent = `
    .shopify-section-group-footer-group { display: none !important; }

    k3-view {
        display: block;
        height: calc(100vh - 202px) !important;
        overflow: hidden;
      }

      botleft {
        position: absolute;
        right: 24px;
        bottom: 85px;
        z-index: 999;
        width: 300px;
    }

    @media (min-width: 768px) {
         html, body { overflow: hidden !important; height: 100% !important; }
    }

    @media (max-width: 767px) {
    k3-view {
        height: calc(100vh - 115px) !important;
      }

      [id^="trustbadge-container"],
      #superchat-widget,
      .announcement-bar,
      botleft {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);
})();

// Tile globals
let tileSqmPerPackage = null;
let tileTilesPerPackage = null;
let tilePricePerPackage = null;
let tileFormatter = null;
let tilePollingId = null;
let tileLastQuantity = 1;

function tileUpdateDisplay(quantity) {
    if (!tileSqmPerPackage) return;

    const totalSqm = tileSqmPerPackage * quantity;
    const totalTiles = tileTilesPerPackage * quantity;
    const totalPrice = tilePricePerPackage * quantity;

    const priceDisplay = document.querySelector('.product-form__info-content .price-main');
    if (priceDisplay) priceDisplay.textContent = '€' + tileFormatter.format(totalPrice);

    const firstSpan = document.querySelector('.product-sqm-info .tile-info-box span:first-child');
    if (firstSpan) firstSpan.innerHTML =
        `📦 <strong>${totalTiles} Stück</strong> | <strong>${tileFormatter.format(totalSqm)} m²</strong> gesamt (${quantity} Paket${quantity > 1 ? 'e' : ''})`;

    const paketLabel = document.querySelector('.quantity-paket-label');
    if (paketLabel) paketLabel.textContent = quantity > 1 ? 'Pakete' : 'Paket';
}

function startTilePolling() {
    if (tilePollingId) clearInterval(tilePollingId);
    tileLastQuantity = 1;

    tilePollingId = setInterval(function() {
        if (!tileSqmPerPackage) {
            clearInterval(tilePollingId);
            return;
        }
        const input = document.querySelector('.quantity-selector__value');
        if (!input) return;
        const qty = parseInt(input.value) || 1;
        if (qty !== tileLastQuantity) {
            tileLastQuantity = qty;
            tileUpdateDisplay(qty);
        }
    }, 300);
}

function initTileProduct() {
    const isTileProduct = document.querySelector('[data-sqm]');
    if (!isTileProduct) return;

    tileSqmPerPackage = parseFloat(isTileProduct.dataset.sqm);
    tileTilesPerPackage = parseInt(isTileProduct.dataset.tiles);
    if (isNaN(tileSqmPerPackage) || isNaN(tileTilesPerPackage)) return;

    const priceDisplay = document.querySelector('.product-form__info-content .price-main');
    if (!priceDisplay) return;

    tilePricePerPackage = parseFloat(priceDisplay.dataset.price) / 100;
    const pricePerSqm = tilePricePerPackage / tileSqmPerPackage;
    const pricePerTile = tilePricePerPackage / tileTilesPerPackage;

    tileFormatter = new Intl.NumberFormat(Shopify.locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    // Mengenbezeichnung ändern
    const quantityLabel = document.querySelector('.product-form__info-item--quantity .product-form__info-title');
    if (quantityLabel) quantityLabel.textContent = 'Menge (Pakete):';

    // Paket-Label
    const existingLabel = document.querySelector('.quantity-paket-label');
    if (existingLabel) existingLabel.remove();
    const quantityPicker = document.querySelector('.quantity-selector--product');
    if (quantityPicker) {
        const paketLabel = document.createElement('span');
        paketLabel.classList.add('quantity-paket-label');
        paketLabel.style.marginLeft = '10px';
        paketLabel.style.fontWeight = 'bold';
        paketLabel.textContent = 'Paket';
        quantityPicker.insertAdjacentElement('afterend', paketLabel);
    }

    // Info-Box
    const infoBox = document.querySelector('.product-sqm-info');
    if (infoBox) {
        infoBox.innerHTML = `
            <div class="tile-info-box">
                <span>📦 <strong>${tileTilesPerPackage} Stück</strong> | <strong>${tileFormatter.format(tileSqmPerPackage)} m²</strong> pro Paket</span>
                <span>🏷️ nur <strong>€${tileFormatter.format(pricePerTile)}</strong> / Stück | 💵 <strong>€${tileFormatter.format(pricePerSqm)}</strong> / m²</span>
            </div>
        `;
    }

    startTilePolling();
}

document.addEventListener('DOMContentLoaded', initTileProduct);
document.addEventListener('variant:changed', function() {
    tileSqmPerPackage = null;
    tileTilesPerPackage = null;
    tilePricePerPackage = null;
    if (tilePollingId) clearInterval(tilePollingId);
    const quantityInput = document.querySelector('.quantity-selector__value');
    if (quantityInput) quantityInput.value = 1;
    setTimeout(initTileProduct, 200);
});